export const formatProductName = (name = '') => {
	return name.replaceAll('/', '<wbr/>/')
}
